import React from "react";
import { StyledSelect } from "../../lib/coc-common-components/StyledComponents/StyledSelect";

// interface ShabbatonSelectionProps {
//   shabbatons: Array<any>;
//   selectedShabbatonId: Number;
//   handleProgramSessionChange: (str: string) => void;
// }

const ShabbatonSelection = ({
  shabbatons,
  selectedShabbatonId,
  handleProgramSessionChange,
}) => {
  const displayableSessions = [...shabbatons];
  if (selectedShabbatonId === 0) {
    displayableSessions.unshift({
      title: "Pegisha Sessions by dates",
      programId: 0,
      id: 0,
    });
  }

  return (
    <StyledSelect>
      <select
        value={selectedShabbatonId.toString() || ""}
        onChange={(e) => handleProgramSessionChange(e.currentTarget.value)}
      >
        {displayableSessions.map((session) => (
          <option key={session.id} value={session.id}>
            {session.title}
          </option>
        ))}
      </select>
    </StyledSelect>
  );
};

export default ShabbatonSelection;
